import {
  FETCH_WAREHOUSE,
  RESET_WAREHOUSE,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const warehouseViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WAREHOUSE:
      return { data: action.payload };
    case RESET_WAREHOUSE:
      return initialState;
    default:
      return state;
  }
};

export default warehouseViewReducer;
